import React, {useState} from 'react'
import {PDCAdditionalBlocksPDP} from '../../page-designer/assets'
import {usePage} from '@salesforce/commerce-sdk-react'
import {Box} from '@salesforce/retail-react-app/app/components/shared/ui'
import {Component, PageContext} from '@salesforce/commerce-sdk-react/components'
import {PDPAdditionalBlocksGroup} from '../../page-designer/layouts'
import {getPageDesignerRegion} from '../../utils/utils'
import {usePageParameters} from '@app/hooks/use-page-parameters'
import useSiteType from '../../hooks/use-site-type'

/**
 * AdditionalBlock component renders additional content blocks for PDP.
 * It uses the Page Designer components to dynamically render content based on the page configuration.
 *
 * @component
 * @returns {JSX.Element} The rendered component.
 */

const AdditionalBlock = () => {
    const PAGEDESIGNER_TO_COMPONENT = {
        'commerce_assets.pdcAdditionalBlocksPDP': PDCAdditionalBlocksPDP,
        'commerce_layouts.pdAdditionalBlocksPDPLayout': PDPAdditionalBlocksGroup
    }

    const [contextValue] = useState({components: PAGEDESIGNER_TO_COMPONENT})
    const {isOutlet} = useSiteType()
    const parameters = usePageParameters('pdp-data' + (isOutlet ? '-outlet' : ''), {includeCountry: true})
    const {data: additionalBlocks} = usePage({parameters})

    const additionalBlocksComponent = getPageDesignerRegion(
        additionalBlocks,
        'main'
    ).components?.find((comp) => comp?.typeId === 'commerce_layouts.pdAdditionalBlocksPDPLayout')

    return (
        <Box>
            <PageContext.Provider value={contextValue}>
                {additionalBlocksComponent ? (
                    <Component component={additionalBlocksComponent} />
                ) : null}
            </PageContext.Provider>
        </Box>
    )
}

export default AdditionalBlock
